module.exports = __webpack_public_path__ + "static/img/bjxh.d4e2ed5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/bjxh.png
// module id = p1Wd
// module chunks = 0